<div class="form-content">
  <form action="" method="post" accept-charset="utf-8" (ngSubmit)="submit(form)" #form="ngForm">
    <div class="col-md-12 col-12 form-box p-0 ">
      <div class="form-section collapse-section open">
        <div class="d-flex align-items-center justify-content-between ">
          <h6 class="text-collapse m-0">{{'Technischer Support'|translate}}</h6>
        </div>
        <div class="form-section">
          <div class="form-row">
            <div class="hasValue form-group col-md-12" [class.has-error]="subject.invalid && (subject.dirty || subject.touched)">
              <label>{{'subject'|translate}} *</label>
              <input type="text" [(ngModel)]="ticket.subject" required class="mnc-control" ngModel name="subject" #subject="ngModel" autofocus="">
            </div>
            <div class="form-group col-md-12 hasValue">
              <label>{{'Priorität'| translate | titlecase }}</label>
              <kendo-dropdownlist name="priority" [data]="priority" ngModel [(ngModel)]="ticket.priority" required></kendo-dropdownlist>
            </div>
            <!-- <div class="form-group col-md-2 hasValue">
              <label>{{'group'| translate | titlecase }}</label>
              <kendo-dropdownlist name="ticketsGroups" [data]="ticketsGroups" ngModel [(ngModel)]="group_id" (valueChange)="selectedGroup()" required [textField]="'name'" [valueField]="'id'"></kendo-dropdownlist>
            </div> -->
            <div class="form-group col-md-12 hasValue">
              <label>{{'category'| translate | titlecase }}</label>
              <kendo-dropdownlist name="ticketsCategory" [data]="ticketsCategory" ngModel [(ngModel)]="ticketCategory" (valueChange)="selectedCategory()" required [textField]="'name'" [valueField]="'name'"></kendo-dropdownlist>
            </div>
          </div>
          <div class="form-row">
            <div class="hasValue form-group col-md-12" [class.has-error]="description.invalid && (description.dirty || description.touched)">
              <label>{{'description'|translate}} *</label>
              <textarea rows="5" cols="30" type="text" [(ngModel)]="ticket.description" required class="mnc-control height-auto" ngModel name="description" #description="ngModel"></textarea>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group mt-2 col-md-12 image-upload">
              <h6>{{'Klicken sie hier und wählen sie die Sektion, in welcher der Fehler auftritt'|translate}} <button type="button" (click)="reportBug()" class="screenshot"><img src="../../../../../../assets/images/screenshot.png" width="20"></button></h6>
              <div class="d-flex">
                <div *ngFor="let shoot of ticket.screenShots;let i = index" (click)="openEditor(shoot.file,shoot.fileName)"><img src="{{ url.ticketFileUrl }}/{{shoot.fileName}}" width="150" class="img-thumbnail"/>
                  <i class="fa fa-times"  (click)="deleteFile(i)" style="cursor: pointer;" aria-hidden="true"></i>
                </div>
              </div>
            </div>
          </div>
        <!-- <div class="form-row">
            <div class="form-group mt-2 col-md-12 image-upload">
              <h6>{{'place files here to upload them'|translate}}</h6>
              <ngx-dropzone [multiple]="false" (change)="onFilesAdded($event)">
                <ngx-dropzone-label><i class="fa fa-upload" aria-hidden="true"></i></ngx-dropzone-label>
              </ngx-dropzone>
            </div>
          </div> -->
          <div class="form-row">
            <div class="form-group col-md-6 d-flex flex-wrap filesection-upload">
              <!-- <div *ngFor="let f of ticket.files" class="file-row d-flex justify-content-between align-items-center mb-4">
                <div>
                  <a  class="d-block" target="_blank" href="{{ url.ticketFileUrl }}/{{f.fileName}}" download="{{ url.ticketFileUrl }}/{{f.fileName}}">
                    {{ f.originalName}}
                  </a>
                </div>
                <i class="fa fa-times"  (click)="deleteFile(f)" style="cursor: pointer;" aria-hidden="true"></i>
              </div> -->
            </div>
          </div>
          <div class="form-group">
            <button type="submit" class="btn-save" [disabled]="onSubmit || form.invalid" kendoButton primary="true"><i *ngIf="onSubmit" class="fa fa-spinner fa-spin"></i>{{'save'|translate}}</button>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<div *ngIf="imageEditor.show">
  <app-pspdfkit [saveUrl]="imageEditor.saveUrl" [readUrl]="imageEditor.readUrl" [fileName]="imageEditor.fileName" (closed)="onEditorClosed($event)"></app-pspdfkit>
</div>
